<div class="tax-rate-select">
  <ng-select
    [class]="{ 'ng-select-sm': component() === 'splitTransaction' }"
    [ngModel]="selectedTaxRateId()"
    (ngModelChange)="updateTaxRate($event)"
    [items]="taxRateOptions()"
    [disabled]="disabled()"
    bindLabel="displayName"
    bindValue="id"
    [clearable]="false"
    [searchable]="true"
    placeholder="Select tax type"
    required="true"
    class="ng-select-sm">
  </ng-select>
</div>
